import type { SuggestionCard } from '@/lib/api'

const KIND_LABEL: Record<string, string> = {
  vague_word: 'Replace vague word',
  missing_dimension: 'Add missing dimension',
  enhancement: 'Enhance',
}

interface Props {
  cards: SuggestionCard[]
  onApply: (card: SuggestionCard, suggestion: string) => void
}

// Renders the LLM suggestion cards. Each suggestion is an individually-applicable button
// (Spec v1: accept/reject suggestion cards).
export default function SuggestionCardList({ cards, onApply }: Props) {
  if (cards.length === 0) return null

  return (
    <ul className="mt-6 space-y-3">
      {cards.map((card) => (
        <li
          key={card.id}
          className="rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-gray-900"
        >
          <div className="flex items-center gap-2">
            <span className="rounded-full bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700 dark:bg-primary-900 dark:text-primary-200">
              {KIND_LABEL[card.kind] ?? card.kind}
            </span>
            {card.dimension && (
              <span className="text-xs uppercase tracking-wide text-gray-400">{card.dimension}</span>
            )}
          </div>

          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            {card.original && (
              <>
                <span className="line-through opacity-70">{card.original}</span>{' → '}
              </>
            )}
            {card.reason}
          </p>

          <div className="mt-3 flex flex-wrap gap-2">
            {card.suggestions.map((s) => (
              <button
                key={s}
                onClick={() => onApply(card, s)}
                className="rounded-lg border border-primary-300 px-3 py-1 text-sm text-primary-700 hover:bg-primary-50 dark:border-primary-700 dark:text-primary-200 dark:hover:bg-primary-950"
              >
                + {s}
              </button>
            ))}
          </div>
        </li>
      ))}
    </ul>
  )
}
